import {
  FETCH_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
  FETCHING_CONTENT_GRID_PERSONALIZATION_SETS_SUCCEEDED,
  FETCHING_CONTENT_GRID_PERSONALIZATION_SETS_FAILED,
  SAVE_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
  SAVING_CONTENT_GRID_PERSONALIZATION_SETS_SUCCEEDED,
  SAVING_CONTENT_GRID_PERSONALIZATION_SETS_FAILED,
  RESET_CONTENT_GRID_PERSONALIZATION,
} from 'constants/actionTypes';

import axios from 'axios';
import buildUrl from 'build-url';
import { createAction } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const LAYOUT_URL = `${apiUrl}/api/2.0/content/layout`;

export const fetchContentGridPersonalizationSets = createAction(
  FETCH_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
  (editorSession, layoutId) => ({
    editorSession,
    layoutId,
  }),
);

const fetchingContentGridPersonalizationSetsSucceeded = createAction(
  FETCHING_CONTENT_GRID_PERSONALIZATION_SETS_SUCCEEDED,
  (editorSession, layoutId, sets) => ({
    editorSession,
    layoutId,
    sets,
  }),
);

const fetchingContentGridPersonalizationSetsFailed = createAction(
  FETCHING_CONTENT_GRID_PERSONALIZATION_SETS_FAILED,
  (editorSession, layoutId, error) => ({
    editorSession,
    layoutId,
    error,
  }),
);

export const saveContentGridPersonalizationSets = createAction(
  SAVE_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
  (editorSession, layoutId, storyboardId, sets, onComplete) => ({
    editorSession,
    layoutId,
    storyboardId,
    sets,
    onComplete,
  }),
);

const savingContentGridPersonalizationSetsSucceeded = createAction(
  SAVING_CONTENT_GRID_PERSONALIZATION_SETS_SUCCEEDED,
  (editorSession, layoutId, sets) => ({
    editorSession,
    layoutId,
    sets,
  }),
);

const savingContentGridPersonalizationSetsFailed = createAction(
  SAVING_CONTENT_GRID_PERSONALIZATION_SETS_FAILED,
  (editorSession, layoutId, error) => ({
    editorSession,
    layoutId,
    error,
  }),
);

export const resetContentGridPersonalization = createAction(
  RESET_CONTENT_GRID_PERSONALIZATION,
  (editorSession) => ({ editorSession }),
);

function* fetchContentGridPersonalizationSetsSaga(action) {
  const { editorSession, layoutId } = action.payload;

  const url = buildUrl(LAYOUT_URL, { path: `${layoutId}/personalization-sets` });

  try {
    const sets = yield call(() => axios.get(url).then((r) => r.data));
    yield put(fetchingContentGridPersonalizationSetsSucceeded(editorSession, layoutId, sets));
  } catch (error) {
    yield put(fetchingContentGridPersonalizationSetsFailed(editorSession, layoutId, error));
  }
}

function* saveContentGridPersonalizationSetsSaga(action) {
  const { editorSession, layoutId, storyboardId, sets, onComplete } = action.payload;

  const url = buildUrl(LAYOUT_URL, { path: `${layoutId}/personalization-sets` });

  try {
    const saved = yield call(() =>
      axios.put(url, { storyboard: storyboardId, sets }).then((r) => r.data),
    );
    yield put(savingContentGridPersonalizationSetsSucceeded(editorSession, layoutId, saved));
    if (onComplete) onComplete(true);
  } catch (error) {
    yield put(savingContentGridPersonalizationSetsFailed(editorSession, layoutId, error));
    if (onComplete) onComplete(false);
  }
}

export default function* contentGridPersonalizationSaga() {
  yield takeEvery(
    FETCH_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
    fetchContentGridPersonalizationSetsSaga,
  );
  yield takeEvery(
    SAVE_CONTENT_GRID_PERSONALIZATION_SETS_REQUEST,
    saveContentGridPersonalizationSetsSaga,
  );
}
